import ReadonlyContentData from '../workflow-viewer/content/ReadonlyContentData';

class PublicationReadonlyContentData extends ReadonlyContentData {
  // Nothing for now
}

export default PublicationReadonlyContentData;
